import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { privateRoute, publicRoute } from "./routes/routes";
import AppLayout from "./components/layout/app-layout";
import { Toaster } from "./components/ui/sonner";
import FullScreenPreview from "./components/common/FullScreenPreview";
import ProtectedRoute from "./routes/ProtectedRoute";
import PublicRoute from "./routes/PublicRoute";
import { DialogProvider } from "./contexts/dialog-context";
import PageNotFound from "./pages/NotFound/page-not-found";

export default function App() {
  return (
    <BrowserRouter>
      <DialogProvider>
        <Routes>
          <Route element={<AppLayout />}>
            <Route element={<ProtectedRoute />}>
              {privateRoute.map((route: any) => (
                <Route
                  path={route.path}
                  element={
                    <Suspense fallback={<div>Loading...</div>}>
                      {route.component}
                    </Suspense>
                  }
                  key={route.path}
                />
              ))}
            </Route>
          </Route>
          <Route element={<PublicRoute />}>
            {publicRoute.map((route: any) => (
              <Route
                path={route.path}
                element={
                  <Suspense fallback={<div>Loading...</div>}>
                    {route.component}
                  </Suspense>
                }
                key={route.path}
              />
            ))}
          </Route>
          <Route element={<ProtectedRoute />}>
            <Route
              path={'/preview'}
              element={
                <Suspense fallback={<div>Loading...</div>}>
                  <FullScreenPreview />
                </Suspense>
              }
              key={'/preview'}
            />
          </Route>
          <Route path="/*" element={<PageNotFound />} />
        </Routes>
        <Toaster closeButton />
      </DialogProvider>
    </BrowserRouter>
  );
}
